<template>
  <div class="home">
    <nav class="navbar app">Retrospectiva</nav>
    <nav class="navbar board">Board bar</nav>
    <div class="board">
      <list v-for="list in lists" :list="list" :key="list.title"></list>
    </div>
  </div>
</template>

<script>
import List from "../components/List";

export default {
  name: "Home",
  components: { List },
  data() {
    return {
      sprint: "Sprint 17",
      lists: {
        startDoing: {
          newNote: { text: "", author: "Anonymous" },
          isWritingNote: false,
          title: "Start Doing",
          notes: [
            {
              text:
                "Add debug mode to the API that prints graphiti validation errors/500 errors in the docker log",
              author: "Matt Gibson",
              votes: ["Anuj Dutta", "Wilson Silva"]
            },
            {
              text:
                "Discuss how parts of the system fit together in the planning e.g. onboarding tokens",
              author: "Matt Gibson",
              votes: ["Matt Gibson", "Wilson Silva"]
            },
            {
              text: "Default WFH",
              author: "Matt Gibson",
              votes: ["Anuj Dutta", "Wilson Silva", "Daniel Delgado"]
            },
            {
              text: "Friday beers",
              author: "Matt Gibson",
              votes: ["Mikey Holland"]
            },
            {
              text: "Hire a designer",
              author: "Daniel Delgado",
              votes: ["Wilson Silva", "Mikey Holland"]
            },
            {
              text: "PR reviews and QA earlier in the sprint",
              author: "Anuj Dutta",
              votes: ["Wilson Silva"]
            },
            {
              text: "Good sprint - nearly finished",
              author: "Anuj Dutta",
              votes: ["Wilson Silva", "Rob"]
            },
            {
              text:
                "Confirm more on features whether to apply everything that is in the attached design",
              author: "Denise Lashlley",
              votes: []
            },
            {
              text: "Flag up more when onboarding fails usual",
              author: "Denise Lashlley",
              votes: ["Mikey Holland"]
            },
            {
              text: "Better preparation for DDoS  attack attempts",
              author: "Wilson Silva",
              votes: ["Wilson Silva", "Rob"]
            }
          ]
        },
        stopDoing: {
          newNote: { text: "", author: "Anonymous" },
          isWritingNote: false,
          title: "Stop Doing",
          notes: [
            {
              text:
                "Surprise requirements that only emerge once the ticket is underway e.g. Meal plans",
              author: "Matt Gibson",
              votes: []
            },
            {
              text: "Horribly laborious local onboarding",
              author: "Matt Gibson",
              votes: ["Wilson Silva", "Denise Lashlley"]
            },
            {
              text: "Coming to the office",
              author: "Daniel Delgado",
              votes: ["Matt Gibson"]
            },
            {
              text:
                "Fixing bugs that are not associated with my actually ticket",
              author: "Denise Lashlley",
              votes: ["Mikey Holland"]
            }
          ]
        },
        continueDoing: {
          newNote: { text: "", author: "Anonymous" },
          isWritingNote: false,
          title: "Continue Doing",
          notes: []
        }
      }
    };
  }
};
</script>

<style scoped>
.home {
  height: 100vh;
  display: grid;
  grid-template-rows: 40px 50px 1fr;
  color: #eee;
}

.navbar {
  padding-left: 10px;
  display: flex;
  align-items: center;
}
.navbar.app {
  background-color: var(--black);
  color: white;
  border-bottom: 1px solid var(--black);
  font-size: 1.5rem;
}
.navbar.board {
  font-size: 1.1rem;
}

.board {
  display: flex;
  overflow-x: auto;
}
.board > * {
  flex: 0 0 auto;
  margin-left: 10px;
}
.board::after {
  content: "";
  flex: 0 0 10px;
}
</style>
